import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import LayoutMixin from '@/views/dashboard/mixins/layout';
import template from '@/../templates/dashboard/billing/payment_method.hbs';
import template_payment_unset from '@/../templates/dashboard/billing/payment_method_unset.hbs';
import template_payment_details from '@/../templates/dashboard/billing/payment_method_details.hbs';


const globalCh = Radio.channel('global');

var PaymentMethodNotSet = Marionette.View.extend({
    className: 'payment-method-details',
    template: Handlebars.compile(template_payment_unset),
    ui: {
        tooltips: '[data-toggle="tooltip"]',
    },
    onRender: function () {
        this.ui.tooltips.tooltip();
    },
});

// Payment method set
var ManageCreditCard = Marionette.View.extend({
    className: 'payment-method-details',
    template: Handlebars.compile(template_payment_details),
    ui: {
        tooltips: '[data-toggle="tooltip"]',
        remove_linked_card: '.remove-linked-card',
        update_linked_card: '.update-linked-card',
    },
    events: {
        'click @ui.remove_linked_card': 'remove_linked_card',
        'click @ui.update_linked_card': 'update_linked_card',
    },
    templateContext: function() {
        var payment_data = this.options.payment_data.attributes;
        var allow_remove_linked_card = false;
        
        if (payment_data.card_type) {
            payment_data.card_icon = this.options.cards[payment_data.card_type] || false;
        }

        // If there is a zero balance the linked card can be removed
        if (!payment_data.balance_due) {
            allow_remove_linked_card = true;
        }

        return {
            payment_data,
            allow_remove_linked_card,
        };
    },
    onRender: function() {
        this.ui.tooltips.tooltip();
    },
    remove_linked_card: function(e) {
        e.preventDefault();
        globalCh.request('show_remove_payment_dialog', this.getOption('payment_data').attributes);
    },
    update_linked_card: function(e) {
        var options = {};
        options.title = 'Update credit card for account ';
        // Alter title of dialog
        globalCh.request('show_stripe_dialog', options);
    },
});

var PlanDetailsWidget = Marionette.View.extend(LayoutMixin).extend({
    className: function () { return "account widget " + this.getWidth(); },
    ui: {
        tooltips: '[data-toggle="tooltip"]',
        payment_method_region: '.payment-method-region',
    },
    regions: {
        payment_method_region: '@ui.payment_method_region',
    },
    template: Handlebars.compile(template),
    modelEvents: {
        'add': 'render'
    },
    initialize: function() {
    },
    onRender: function () {
        if (this.options.payment_data.attributes.card_type) {
            this.showChildView('payment_method_region', new ManageCreditCard({
                payment_data: this.getOption('payment_data'),
                cards: this.options.cards,
            }));
        } else {
            this.showChildView('payment_method_region', new PaymentMethodNotSet());
        }
    },
    templateContext: function () {
        var data = {};
        return data;
    }
});

export default PlanDetailsWidget;



